import React from "react";
import { connect } from "react-redux";
import { vehicleColumns } from "../../../tableColumns/table-columns";
import { vehicleJson } from "../../../DynamicFormsJson/MastersJSON/vehicle";
import { getUpdatedVehicleNoListByStockholder } from "../../../Slice/veichleSlice.slice";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import DynamicTabwiseTable from "../../../components/dynamicscreens/DynamicTabwiseTable";
import { noInternetMsg, serverMsg } from "../../../config/messageconstant";
import endpoint from "../../../config/endpoints";
import { downloadF } from "../../PDF/PDFDownload";

class VehicleList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabValue: 1,
      moduleObjDataObj: {},
      isLog: true,
      dynamicMasterData: {
        VehicleListInActive: this.props.vehicleList?.vehicle.filter(
          (row) => row.isActive == 0
        ),
        VehicleListActive: this.props.vehicleList?.vehicle.filter(
          (row) => row.isActive == 1
        ),
      },
      tabList: [
        {
          label: "Active",
          allyProps: 0,
          columns: vehicleColumns,
          showExcelDownload: true,
          changeExcelURL: "get-vehicle-data",
          isActionColActive: true,
          value: "VehicleListActive",
        },
        {
          label: "InActive",
          allyProps: 1,
          columns: vehicleColumns,
          showExcelDownload: true,
          changeExcelURL: "get-vehicle-data",
          isActionColActive: true,
          value: "VehicleListInActive",
        },
      ],
    };
  }

  componentDidMount() {
    const moduleObjData = localStorage.getItem("moduleObj");
    const moduleObjDataObj =
      moduleObjData != null ? JSON.parse(moduleObjData) : {};

    if (
      localStorage.getItem("showFilterDataWiseExcel") &&
      localStorage.getItem("showFilterDataWiseExcel") == 1
    ) {
      this.setState((prevState) => ({
        tabList: prevState.tabList.map((tab) => ({
          ...tab,
          showExcelDownload: false,
        })),
      }));
    }

    this.setState({ moduleObjDataObj });

    this.getListData();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.stockStakeHolderType !== nextProps.stockStakeHolderType) {
      if (
        this.props.stockStakeHolderType?.stockStakeHolderType !==
        nextProps.stockStakeHolderType?.stockStakeHolderType
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stockStakeHolderTypeDetail:
              nextProps.stockStakeHolderType?.stockStakeHolderType,
          },
        });
      }
    }
    if (this.props.vehicleList !== nextProps.vehicleList) {
      if (this.props.vehicleList?.vehicle !== nextProps.vehicleList?.vehicle) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            VehicleListActive: nextProps.vehicleList?.vehicle
              .filter((row) => row.isActive == 1)
              .map((rowData, index) => {
                return { ...rowData, index: index + 1 };
              }),
            VehicleListInActive: nextProps.vehicleList?.vehicle
              .filter((row) => row.isActive == 0)
              .map((rowData, index) => {
                return { ...rowData, index: index + 1 };
              }),
          },
        });
      }
    }
  }

  getTabValue = (rowValue) => {
    this.setState({
      tabValue: rowValue == 0 ? 1 : 0,
    });
  };

  getListData = async () => {
    const {
      getUpdatedVehicleNoListByStockholder,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getUpdatedVehicleNoListByStockholder({}).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  generateStaticExcelMethod = () => {
    const { showLoador, showNotification } = this.props;
    showLoador({ loador: true });
    downloadF({
      url: endpoint.exportData + "/get-vehicle-data",
      ext: "xls",
      openNewTab: true,
    }).then((response) => {
      showLoador({ loador: false });
      if (!response) {
        showNotification({
          msg: serverMsg,
          severity: "error",
        });
      }
    });
  };

  render() {
    const { vehicleList } = this.props;
    const { dynamicMasterData, tabList, tabValue } = this.state;
    return (
      <>
        <DynamicTabwiseTable
          dynamicMasterData={dynamicMasterData}
          searchList={vehicleJson.searchList}
          formPath={vehicleJson.formPath}
          screenTitle={vehicleJson.screenTitle}
          fieldMeta={vehicleJson.fieldMeta}
          showPdfDownload={vehicleJson.showPdfDownload}
          showExcelDownload={true}
          isExcelStaticUrl={true}
          filterDataExcel={true}
          pdfFileName={vehicleJson.pdfFileName}
          excelFileName={vehicleJson.excelFileName}
          showAddButton={vehicleJson.showAddButton}
          tableColumnsToFilter={vehicleJson.tableColumnsToFilter}
          tableColumns={vehicleColumns}
          tableData={vehicleList?.vehicle}
          apiBaseURL={vehicleJson.apiBaseURL}
          callApi={false}
          isActiveURL={vehicleJson.isActiveURL}
          showAddButtonInTable={false}
          onClickAdd={this.onClickAdd}
          openFormPath={vehicleJson.openFormPath}
          searchButtonGrid={vehicleJson.searchButtonGrid}
          getTableDataById={true}
          rowStatusTrue={false}
          onSearchData={this.getListData}
          tabList={tabList}
          isNote={true}
          isNoteValue={"Add Vehicle Number"}
          rowList={dynamicMasterData}
          formPathStatic={false}
          showHeadEdit={true}
          staticEdit={false}
          deleteStaticTrue={false}
          getTabValue={this.getTabValue}
          showHeadDelete={true}
          showPegination={true}
          generateStaticExcelMethod={this.generateStaticExcelMethod}
          showView={true}
          formPathView={vehicleJson.formPathView}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  vehicleList: state.vehicle,
});
const mapDispatchToProps = {
  getUpdatedVehicleNoListByStockholder,
  showLoador,
  showNotification,
};
export default connect(mapStateToProps, mapDispatchToProps)(VehicleList);
